module.exports = __webpack_public_path__ + "media/images/sun-2038ed1267a2e2b8e5601465a4264e7d.jpg";